import filter from 'lodash/filter'
import intersection from 'lodash/intersection'
import range from 'lodash/range'
import {type ParserT, number, string, record} from '@freckle/parser'

import {type RlDomainIdT} from '@frontrow/console/src/entities/types/rl-domain-id'
import * as RlDomainId from '@frontrow/console/src/entities/types/rl-domain-id'

export type RlDomainT = {
  name: string
  id: RlDomainIdT
  lowestGrade: number
  highestGrade: number
  k5ThumbnailImage: string
  k5PathwayImage: string
  msThumbnailImage: string
  msPathwayImage: string
}

export const parseDomainAttrs: ParserT<RlDomainT> = record({
  id: RlDomainId.parse,
  name: string(),
  lowestGrade: number(),
  highestGrade: number(),
  k5ThumbnailImage: string(),
  k5PathwayImage: string(),
  msThumbnailImage: string(),
  msPathwayImage: string()
})

/** @internal */
export function domainRangeOverlaps(
  domain: RlDomainT,
  testRange: {
    min: number
    max: number
  }
): boolean {
  const domainRange = range(domain.lowestGrade, domain.highestGrade + 1)
  const tRange = range(testRange.min, testRange.max + 1)

  return intersection(domainRange, tRange).length > 0
}

/** @internal */
export function rejectDomainsByRange(
  domains: Array<RlDomainT>,
  testRange: {
    min: number
    max: number
  }
): Array<RlDomainT> {
  return filter(domains, d => !domainRangeOverlaps(d, testRange))
}
